// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24oUH","field":"styles_field__1RXzS","fieldCol":"styles_fieldCol__Y_B0C","diffCol":"styles_diffCol__1JaJN","diff":"styles_diff__3frq2"};